import { render, staticRenderFns } from "./Iconfont.vue?vue&type=template&id=536f4be7&"
import script from "./Iconfont.vue?vue&type=script&lang=ts&"
export * from "./Iconfont.vue?vue&type=script&lang=ts&"
import style0 from "./Iconfont.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports